import React, {useEffect, useRef} from 'react';
import Chat from './Chat';

const RightChatPanel = ({onClose}) => {
    const chatEndRef = useRef(null);
    const roomSelectorRef = useRef(null);

    const scrollToBottom = () => {
        chatEndRef.current?.scrollIntoView({behavior: 'instant'});
    };

    useEffect(() => {
        scrollToBottom();
    }, []);

    return (
        <>
            <div className="bubble-header">
                <div ref={roomSelectorRef} className={`room-selector`}>
                    <span className="room-label">
                        {'General'}
                        <span className="dropdown-arrow">▼</span>
                    </span>
                </div>
                <div onClick={onClose}>
                    <img src="/images/round-close-button.svg" alt="Close"
                         style={{width: '32px', height: '32px', cursor: 'pointer'}}/>
                </div>
            </div>
            <div className="floating-chat-container">
                <Chat/>
                <div ref={chatEndRef}/>
            </div>
        </>
    );
};

export default RightChatPanel;